import React from 'react';
import { connect } from 'react-redux'

class DynamicTitleV2 extends React.Component {
	render() {
		let lastest_time = "";

		if (this.props.lastest_time !== null) {
			const dateString = this.props.lastest_time;
			const date = new Date(dateString);

			const month = date.toLocaleString('en-US', { month: 'long' });
			const day = date.getDate();
			const year = date.getFullYear();

			lastest_time = ` since ${month} ${day}, ${year}`;
		}

		var timestring = __("Custom Timeframe");
		if (this.props.timeframe == "today") {
			timestring = __("Today");
		} else if (this.props.timeframe == "yesterday") {
			timestring = __("Yesterday");
		} else if (this.props.timeframe == "weekToDate") {
			timestring = __("Week to Date");
		} else if (this.props.timeframe == "monthToDate") {
			timestring = __("Month to Date");
		} else if (this.props.timeframe == "lifetime") {
			timestring = __("Lifetime") + lastest_time;
		} else if (this.props.timeframe == "last30") {
			timestring = __("Last 30 Days");
		}

		var other = "";
		if (this.props.other == "chats_requested") {
			other = __("Chats Requested");
		} else if (this.props.other == "chats_started") {
			other = __("Chats Started");
		} else if (this.props.other == "links_sent") {
			other = __("Review Links Sent");
		} else if (this.props.other == "chats_waiting") {
			other = __("Chats Still Open");
		}

		var statusString = "";
		if (this.props.status != null && this.props.status !== "null") {
			statusString = !window.feedbackStatus[this.props.status] ? "" : window.feedbackStatus[this.props.status].label
		} else {
			statusString = __("All");
		}

		if (this.props.status === "feedbacker") {
			other = (this.props.user_table.firstname ?? "") + " " + (this.props.user_table.lastname ?? "") + " "
			timestring = __("Lifetime");
			statusString = "";
		}

		return (
			<span>
				{this.props.feedback_detail ? __('Feedback Details') : (
					__("Feedback History - ") + statusString + ' ' + other
					+ "(" + timestring + ")"
				)}

			</span>
		);
	}
}

function mapStateToProps(state) {
	return { user_table: state.user_table, status: state.status, other: state.other_filter, departments: state.departments, timeframe: state.timeframe, feedback_detail: state.feedback_detail, lastest_time: state.lastest_time }
}

export default connect(mapStateToProps)(DynamicTitleV2)
